"use strict";
exports.__esModule = true;
exports.GetPadding = function () { return "padding: 24px 48px;"; };
